import React, { useState, useEffect } from 'react';
import { io } from "socket.io-client";
import { getLocalStorageCustom } from "../common/utils/StorageUItils";
import { REDISCHANNELS } from "../common/constant/common-constants";

let socketInstance = null;
let bedDetailAction = null;
let wardDetailAction = null;
let bedIdAction = null;
let patientDataAction = null;
let deviceVitalDataAction = null;

let deviceEcgWaveformDataAction = null;
let deviceHrWaveformDataAction = null;
let alarmDataAction = null;
let ventilatorAlarmDataAction = null;
let ventilatorAdditionalFeaturesDataAction = null;
let monitorHeartbeatAction = null;
let ventilatorHeartbeatAction = null;
let notificationDataAction = null;
let ventilatorVitalDataAction = null;
let ventilatorPatientModeAlarmProfileDataAction = null;
let ventilatorWaveformData = null;
let ventilatorStandbyDataAction = null;
let ventilatorModuleConnectionStatusAction = null
let monitorEcgWaveformStream = null;
let monitorSecondaryWaveformStream = null;
let currentUpdateFilters = null;

export const setBedDetailsAction = (bdAction) => {
    bedDetailAction = bdAction;
}

export const setCurrentUpdateFilters = (data) => {
    currentUpdateFilters = data;
}

export const setWardDetailAction = (wdAction) => {
    wardDetailAction = wdAction;
}

export const setBedIdAction = (bIdAction) => {
    bedIdAction = bIdAction;
}

export const setPatientDataAction = (pdAction) => {
    patientDataAction = pdAction;
}

export const setDeviceVitalDataAction = (ddAction) => {
    deviceVitalDataAction = ddAction;
}

export const setMonitorHeartbeatAction = (ddAction) => {
    monitorHeartbeatAction = ddAction;
}

export const setDeviceEcgWaveformDataAction = (dewdAction) => {
    deviceEcgWaveformDataAction = dewdAction;
}

export const setDeviceHrWaveformDataAction = (dhwdAction) => {

    deviceHrWaveformDataAction = dhwdAction;
}

export const setAlarmDataAction = (adAction) => {
    alarmDataAction = adAction;
}

export const setVentilatorAlarmDataAction = (adAction) => {
    ventilatorAlarmDataAction = adAction;
}

export const setVentilatorAdditionalFeaturesDataAction = (adAction) => {
    ventilatorAdditionalFeaturesDataAction = adAction;
}

export const setVentilatorModuleConnectionStatusAction = (adAction) => {
    ventilatorModuleConnectionStatusAction = adAction;
}

export const setVentilatorHeartbeatDataAction = (hbAction) => {
    ventilatorHeartbeatAction = hbAction;
}

export const setNotificationDataAction = (ndAction) => {
    notificationDataAction = ndAction;
}

export const setVentilatorVitalDataAction = (vDataAction) => {
    ventilatorVitalDataAction = vDataAction;
}

export const setVentilatorPatientModeAlarmProfileDataAction = (vPatientModeAlarmProfileDataAction) => {
    ventilatorPatientModeAlarmProfileDataAction = vPatientModeAlarmProfileDataAction;
}

export const setVentilatorWaveformData = (vWaveformData) => {
    ventilatorWaveformData = vWaveformData;
}

export const setMonitorEcgWaveformStream = (cb) => {
    monitorEcgWaveformStream = cb;
}

export const setMonitorSecondaryWaveformStream = (cb) => {
    monitorSecondaryWaveformStream = cb;
}

export const setVentilatorStandbyDataAction = (ventilatorStandby) => {
    ventilatorStandbyDataAction = ventilatorStandby
}


// export const openSocketConnection = (hospitalData) => {

//     let hospitalId = getLocalStorageCustom('hospitalId');
//     if (socketInstance === null) {
//         // console.log("opening new socket connection");
//         socketInstance = io(process.env.REACT_APP_BASE_URL, {

//             transports: ['websocket'],
//             query: {
//                 channelName: hospitalId,
//             }
//         });

//     } else if (socketInstance.connected === false) {
//         socketInstance.connect();

//     }
//     handleMessages();
// }

export const openSocketConnection = () => {
    const hospitalId = getLocalStorageCustom("hospitalId");

    if (!socketInstance) {
        socketInstance = io(process.env.REACT_APP_BASE_URL, {
            transports: ["websocket"],

            query: {
                channelName: hospitalId,
            },

            //  IMPORTANT PART
            reconnection: true,
            reconnectionAttempts: Infinity,   // keep trying forever
            reconnectionDelay: 2000,          // 2s
            reconnectionDelayMax: 10000,      // max 10s
            timeout: 20000,                  // 20s timeout
        });

        attachListeners();

        document.addEventListener("visibilitychange", () => {
            // console.log("Document visibility :", document.visibilityState);
            // console.log("Socket connection status:", socketInstance ? socketInstance.connected : "No socket instance");
            if (
                document.visibilityState === "visible" &&
                socketInstance &&
                !socketInstance.connected
            ) {
                // console.log("Tab became active -> forcing reconnect");
                socketInstance.connect();
            }
        });
    }

    if (!socketInstance.connected) {
        socketInstance.connect();
    }
};

function attachListeners() {
    socketInstance.on("connect", () => {
        // console.log(" Socket connected");
        if (currentUpdateFilters) { socketInstance.emit("UPDATE_FILTERS", currentUpdateFilters); }
    });

    socketInstance.on("disconnect", (reason) => {
        // console.log(" Socket disconnected:", reason);
    });

    socketInstance.on("reconnect_attempt", () => {
        // console.log(" Trying to reconnect...");
    });

    socketInstance.on("reconnect", () => {
        // console.log(" Reconnected successfully");
        if (currentUpdateFilters) { socketInstance.emit("UPDATE_FILTERS", currentUpdateFilters); }
    });

    socketInstance.on("connect_error", (err) => {
        // console.log(" Connection error:", err.message);
    });

    handleMessages();
}

export const closeSocketConnection = () => {
    socketInstance.close();
    socketInstance = null;
}

export const setbedCartViewRedisChannels = (wardId) => {
    // console.log("setbedCartViewRedisChannels called with wardId:::::", wardId);
    if (socketInstance === null) {
        // console.log("setbedCartViewRedisChannels:::::socketInstance is null");
        return;
    }
    let hospitalId = getLocalStorageCustom('hospitalId');

    const data = {
        bedCartViewRedisChannels: [

            //NX5 Channels
            REDISCHANNELS.NX5_REDIS_WEBSOCKET_CHANAL_NAME.NOCCARC_PM_HEARTBEAT_MSG_DATA,
            REDISCHANNELS.NX5_REDIS_WEBSOCKET_CHANAL_NAME.NOCCARC_PM_ACTIVE_ALARMS_DATA,
            REDISCHANNELS.NX5_REDIS_WEBSOCKET_CHANAL_NAME.NOCCARC_PM_ACTIVE_MONITOR_PARAMETER_DATA,

            //VENTILATOR Channels
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_ACTIVE_MONITOR_DATA,
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_ACTIVE_ALARMS_DATA,
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_HEARTBEAT_MSG_DATA,
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_PATIENT_MODE_ALARMPROFILE_DATA,
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_VENTILATION_STATUS_DATA,
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_ADDTIONAL_FEATURES_DATA,
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_MODULE_CONNECTION_STATUS_DATA,

        ],
        deviceViewRedisChannels: null
    }


    const emitPacket = {
        hospitalId,
        selectedWardId: wardId,
        data: data
    };

    socketInstance.emit("UPDATE_FILTERS", emitPacket);

    setCurrentUpdateFilters(emitPacket);

};

export const setdeviceViewRedisChannels = (wardId, bedId, deviceType) => {
    //console.log("setdeviceViewRedisChannels called with wardId:::::", wardId, " bedId::::", bedId, " deviceType::::", deviceType);
    if (!socketInstance) {
        // console.log("setdeviceViewRedisChannels ::::: socketInstance is null");
        return;
    }

    const hospitalId = getLocalStorageCustom("hospitalId");

    let deviceSpecificChannels = [];

    if (deviceType === "NOCCARC_PM_NX5") {
        deviceSpecificChannels = [
            REDISCHANNELS.NX5_REDIS_WEBSOCKET_CHANAL_NAME.NOCCARC_PM_SECONDARY_WAVEFORM_DATA,
            REDISCHANNELS.NX5_REDIS_WEBSOCKET_CHANAL_NAME.NOCCARC_PM_ECG_WAVEFORM_DATA,

        ];
    } else if (deviceType === "VENTILATOR") {
        deviceSpecificChannels = [
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_WAVEFORM_DATA,

        ];
    }

    const data = {
        bedCartViewRedisChannels: [
            // NX5
            REDISCHANNELS.NX5_REDIS_WEBSOCKET_CHANAL_NAME.NOCCARC_PM_HEARTBEAT_MSG_DATA,
            REDISCHANNELS.NX5_REDIS_WEBSOCKET_CHANAL_NAME.NOCCARC_PM_ACTIVE_ALARMS_DATA,
            REDISCHANNELS.NX5_REDIS_WEBSOCKET_CHANAL_NAME.NOCCARC_PM_ACTIVE_MONITOR_PARAMETER_DATA,

            // Ventilator
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_ACTIVE_MONITOR_DATA,
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_ACTIVE_ALARMS_DATA,
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_HEARTBEAT_MSG_DATA,
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_PATIENT_MODE_ALARMPROFILE_DATA,
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_VENTILATION_STATUS_DATA,
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_ADDTIONAL_FEATURES_DATA,
            REDISCHANNELS.VENTILATOR_REDIS_WEBSOCKET_CHANAL_NAME.VENTILATOR_MODULE_CONNECTION_STATUS_DATA,
        ],
        deviceViewRedisChannels: {
            bedId,
            deviceType: deviceType,
            channelNames: deviceSpecificChannels,
        },
    }

    const emitPacket = {
        hospitalId,
        selectedWardId: wardId,
        data: data
    };

    socketInstance.emit("UPDATE_FILTERS", emitPacket);

    setCurrentUpdateFilters(emitPacket);

};

const handleMessages = () => {

    if (socketInstance === null) {
        // console.log("handleMessages::::socketInstance is null");
        return;
    }
    socketInstance.on("ward_details", (msg) => {
        // console.log("socket ward_details: " + msg);
        if (wardDetailAction) wardDetailAction(JSON.parse(msg));
    });
    socketInstance.on("patient_data", (msg) => {
        // console.log("socket patient_data: " + msg);
        if (patientDataAction) patientDataAction(JSON.parse(msg))
    });


    //NX5
    socketInstance.on("noccarc_pm_active_monitor_parameter_data", (msg) => {
        //  console.log("socket NX5 patient_data: " + msg);
        if (deviceVitalDataAction) deviceVitalDataAction(JSON.parse(msg));
    });
    socketInstance.on("noccarc_pm_heartbeat_msg_data", (msg) => {
        // console.log("socket monitor_heartbeat_msg_data: ", msg);
        if (monitorHeartbeatAction) monitorHeartbeatAction(JSON.parse(msg));
    });
    socketInstance.on("noccarc_pm_ecg_waveform_data", (msg) => {
        // console.log("Data recevied in Socket------------------------------->", msg)
        const data = JSON.parse(msg);
        if (deviceEcgWaveformDataAction) deviceEcgWaveformDataAction(data);
        if (monitorEcgWaveformStream) monitorEcgWaveformStream(data);
    })
    socketInstance.on("noccarc_pm_secondary_waveform_data", (msg) => {
        // console.log("socket noccarc_pm_secondary_waveform_data-------------------> ", msg);
        const data = JSON.parse(msg);
        if (deviceHrWaveformDataAction) deviceHrWaveformDataAction(data);
        if (monitorSecondaryWaveformStream) monitorSecondaryWaveformStream(data);
    })
    socketInstance.on("noccarc_pm_active_alarms_data", (msg) => {
        // console.log("device_alarms_data:" + msg);
        if (alarmDataAction) alarmDataAction(JSON.parse(msg));
    });

    //Ventilator
    socketInstance.on("ventilator_patient_mode_alarm_profile_data", (msg) => {
        // console.log("ventilator_patient_mode_alarm_profile_data------------>", JSON.parse(msg))
        if (ventilatorPatientModeAlarmProfileDataAction) ventilatorPatientModeAlarmProfileDataAction(JSON.parse(msg));
    })
    socketInstance.on("ventilator_active_alarms_data", (msg) => {
        //  console.log("ventilator_active_alarms_data", msg)
        if (ventilatorAlarmDataAction) ventilatorAlarmDataAction(JSON.parse(msg));
    })
    socketInstance.on("ventilator_heartbeat_msg_data", (msg) => {
        // console.log("ventilator_heartbeat_msg_data", msg);
        if (ventilatorHeartbeatAction) ventilatorHeartbeatAction(JSON.parse(msg));
    })
    socketInstance.on("ventilator_monitor_data", (msg) => {
        // console.log("ventilator_monitor_data packet------------------------->", JSON.parse(msg))
        if (ventilatorVitalDataAction) ventilatorVitalDataAction(JSON.parse(msg));
    })
    socketInstance.on("ventilator_waveform_data", (msg) => {
        // console.log("ventilator_waveform_data", JSON.parse(msg))
        if (ventilatorWaveformData) ventilatorWaveformData(JSON.parse(msg));
    })
    socketInstance.on("ventilator_addtional_features_data", (msg) => {
        // console.log("ventilator_addtional_features_data", msg)
        if (ventilatorAdditionalFeaturesDataAction) ventilatorAdditionalFeaturesDataAction(JSON.parse(msg));
    })
    socketInstance.on("ventilator_ventilation_status_data", (msg) => {
        //  console.log("ventilator_ventilation_status_data>>", JSON.parse(msg))
        if (ventilatorStandbyDataAction) ventilatorStandbyDataAction(JSON.parse(msg));
    })
    socketInstance.on("ventilator_module_connection_status_data", (msg) => {
        // console.log("ventilator_module_connection_status_data>>", JSON.parse(msg))
        if (ventilatorModuleConnectionStatusAction) ventilatorModuleConnectionStatusAction(JSON.parse(msg));
    })
}






